import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, forwardRef, Inject, OnInit } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ExpandedLTR, ExpandedRTL, MultilevelMenuService } from 'ng-material-multilevel-menu';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { MESSAGE_TYPE, PATTERT_SYMBOL, PARTERT_PHONENUMBER, 
    PATTERT_PASSWORD, PATTERT_SYMBOL_NO, 
    PATTERT_PASSWORD_NO, BLACKLISTPASS, KEY_LOCALSTORAGE, 
    PATTERN_DATE2, PATTERT_EMAIL, PATTERN_CMND, PATTERT_HOTEN, DATE_PATTERN} from 'src/app/constant/constant';
import { DmDungChungService } from 'src/app/data/service/dm-dung-chung.service';
import { UserService } from 'src/app/data/service/user.service';
import { FormControl, FormGroup, Validators, FormGroupDirective, FormBuilder, FormArray } from '@angular/forms';
import { FunctionService } from 'src/app/data/service/function-service';
import { SnackbarService } from 'src/app/data/service/snackbar.service';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';
import { NccSpinner } from 'src/app/data/service/nccSpinner.service';
import { AuthService } from 'src/app/core/service/auth.service';
import { DOMAIN_CONSTANT } from 'src/app/constant/domain-constant';
import { HttpClient } from '@angular/common/http';
import { ValidationService } from 'src/app/data/service/validation.service';
import { ViecLamService } from 'src/app/data/service/viec-lam.service';
import { DatePipe } from '@angular/common';
import { RegionService } from 'src/app/data/service/region.service';
import { Subscription } from 'rxjs';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { PICK_FORMATS } from 'src/app/data/service/config.service';
import { VNDateAdapter } from 'src/app/data/schema/vi-date-picker-adapter';
import { DomainContextService } from 'src/app/core/service/domain-context.service';
@Component({
  selector: 'app-admin-layout-sidenav',
  templateUrl: './admin-layout-sidenav.component.html',
  styleUrls: ['./admin-layout-sidenav.component.scss'],
  providers: [          
    { provide: DateAdapter, useClass: VNDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: PICK_FORMATS },
    DatePipe,MultilevelMenuService
  ],
  animations: [ExpandedRTL, ExpandedLTR]
})
export class AdminLayoutSidenavComponent implements OnInit {
  menu: any;
  phanHe;
  user;
  maTinh;
  logoSrc = 'assets/logo/logo-title.png';
  public isAGGIOC: boolean;
  constructor(private breakpointObserver: BreakpointObserver,
    private spinner: NccSpinner,
    public http: HttpClient,
    private regionService: RegionService,
    private router: Router,
    @Inject(forwardRef(() => TranslateService)) private translateService: TranslateService,
    private afMessaging: AngularFireMessaging,
    private danhMucServicer: DmDungChungService,
    private userService: UserService,
    private functionService: FunctionService,
    private message: SnackbarService,
    private translate: TranslateService,
    private auth: AuthService,
    private viecLamService: ViecLamService,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private validationService: ValidationService,
    private menuService: MultilevelMenuService,
    private domainContext: DomainContextService
) {
    this.phanHe = (window.location.pathname).toString().split('/')[1];
    var lang = localStorage.getItem(KEY_LOCALSTORAGE.LANGUAGE);
    this.localeId = lang ? lang : KEY_LOCALSTORAGE.LANGUAGE_DEFAULT;
    this.user = JSON.parse(localStorage.getItem('user'));
    this.logoSrc = this.domainContext.getLogoSrc();
    this.domainContext.applyFavicon();
    this.menu = this.applyProvinceMenuRules(this.getCurrentMenuFromStorage());
    this.isAGGIOC = (this.user.maTinhBhxh == '89' && this.router.url.startsWith("/ioc/"));
    $(document).on("click", ".icon-notify", function () {
      var $this = $(this);
      if ($this.hasClass("active")) {
        $this.removeClass("active");
        $this.addClass("swing");
        $this.find("i").addClass("fa-bell");
        $this.find("i").removeClass("fa-window-close");
        $(".sidebar-notify").removeClass("active");
      }
      else {
        $this.addClass("active");
        $this.removeClass("swing");
        $this.find("i").removeClass("fa-bell");
        $this.find("i").addClass("fa-window-close");
        $(".sidebar-notify").addClass("active");
      }
    });
    this.maTinh = DOMAIN_CONSTANT.find(p => p.domain == window.location.hostname).maTinh;

  }

  private getMenuFromStorage(): any[] {
    const store = localStorage.getItem('menu');
    if (!store) {
      return [];
    }

    try {
      return JSON.parse(store) || [];
    } catch (e) {
      return [];
    }
  }

  private isLaoCaiMergedMenuContext(): boolean {
    return this.domainContext.applyLaoCaiFlow();
  }

  private getCurrentMenuFromStorage(): any[] {
    const allMenu = this.getMenuFromStorage();
    const currentKyHieu = this.isLaoCaiMergedMenuContext() ? 'btxh' : this.getkyHieuPhanHe(this.phanHe);
    let currentMenu = allMenu.filter(p => p.kyhieu === currentKyHieu);

    if (this.isLaoCaiMergedMenuContext()) {
      const danhSachNhomQuyen = this.user && this.user.danhSachNhomQuyen ? this.user.danhSachNhomQuyen : [];
      const grantedKyHieu = danhSachNhomQuyen.map(item => item.KY_HIEU);
      const tailKyHieu = ['user', 'admin'];

      const otherMenu = allMenu.filter(p => p.kyhieu !== currentKyHieu && grantedKyHieu.includes(p.kyhieu));
      const headMenu = otherMenu.filter(p => !tailKyHieu.includes(p.kyhieu));
      let tailMenu = [];

      tailKyHieu.forEach(kyHieu => {
        tailMenu = tailMenu.concat(otherMenu.filter(p => p.kyhieu === kyHieu));
      });

      currentMenu = currentMenu.concat(headMenu).concat(tailMenu);
    }

    return currentMenu;
  }

  private applyProvinceMenuRules(menu: any[]): any[] {
    if (!menu) {
      return [];
    }

    // Remove item with id 385 if maTinh is 89
    if (this.user && this.user.maTinhBhxh === '89') {
      return menu.filter(item => item.Id !== 385);
    }

    return menu;
  }

  private async ensureMenuLoaded() {
    if (this.menu && this.menu.length > 0) {
      return;
    }

    try {
      const listMenu = await this.userService.getMenu().toPromise();
      localStorage.setItem('menu', JSON.stringify(listMenu || []));
      this.menu = this.applyProvinceMenuRules(this.getCurrentMenuFromStorage());
    } catch (e) {
      this.menu = [];
    }
  }

  username: string = "Người lạ";
  async ngOnInit() {
    await this.apiDanhMucQuyenXuLy();
    this.username = this.getHoTen();
    await this.ensureMenuLoaded();
    this.getMenu();
    this.getNotification();
    this.listenNotification();
    this.checkTinhTitle();
    this.checkingPasswordExpire();
    this.maTinh = this.user.maTinhBhxh;
  }

  async apiDanhMucQuyenXuLy() {
    let tmp = [];
    tmp = this.user.danhSachNhomQuyen.map(p => p.KY_HIEU);
    let data = await this.userService.userPermissionList().toPromise();
    if (tmp.includes('admin') || this.user.superAdmin == 1) {
      this.roleUser = data;
    } else {
      data.forEach(item => {
        if (tmp.includes(item.KY_HIEU)) {
          this.roleUser.push(item);
        }
      })
    }
  }

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset).pipe(map(result => result.matches), shareReplay());

  getHoTen() {
    return JSON.parse(localStorage.getItem('user')).hoTen;
  }

  getkyHieuPhanHe(phanHe) {
    switch (phanHe) {
      case 'quan-tri-he-thong':
          return 'admin';
      case 'nguoi-dung':
          return 'user';
      case 'tre-em':
          return 'te';
      case 'nguoi-co-cong':
          return 'ncc';
      case 'trang-chu':
          return 'bcsl';
      case 'lao-dong-viec-lam':
          return 'ldvl';
      case 'btxh-ho-ngheo':
          return 'btxh';
      case 'cong-dan':
          return 'congdan';
      case 'mat-tran-to-quoc':
          return 'mttq';
      case 'bao-hiem-that-nghiep':
          return 'bhtn';
      case 'xuat-khau-lao-dong':
          return 'xkld';
      case 'ma-tuy':
          return 'matuy';
      case 'giam-ngheo-ben-vung':
          return 'gnbv';
      case 'baocao-gdnn':
          return 'gdnn-baocao';
      case 'binh-dang-gioi':
          return 'bdg';
      case 'cac-hoi':
          return 'cachoi';
      case 'thanh-tra':
          return 'thanhtra';
      case 'van-phong':
          return 'vanphong';
      case 'ke-hoach-tai-chinh':
          return 'khtc';
      case 'ioc':
          return 'ioc';
      case 'ho-trung-binh':
          return 'htb-old';
      case 'ho-trung-binh-new':
          return 'htb';
      case 'bao-cao-tong-hop':
        return 'bcth';
      default:
          return phanHe;
    }
  }


  public appitems: any[] = [];
  public originMenu: any[] = [];
  config = {
    customTemplate: true,
    paddingAtStart: true,
    interfaceWithRoute: true,
    selectedListFontColor: `white`,
    highlightOnSelect: true,
    collapseOnSelect: true,
    useDividers: false,
    rtlLayout: false,
    fontColor: `#fff`,
  };

  getMenu() {
    if (this.menu && this.menu.length != 0) {
      var nodes = this.menu.filter(p => !p.IdParent);
      let tmp = [];
      nodes.forEach(node => {
        let chil = this.getChildrentMenuList(node);
        if ((!node.Path || node.Path == '') && chil.length == 0) return;
        tmp.push({
          label: node.MenuName,
          link: node.Path ? '/' + node.Path : node.Path,
          kyhieu: node.kyhieu,
          items: chil
        });
      });
      if (this.isLaoCaiMergedMenuContext()) {
        let laoCaiItems = [];
        tmp.forEach(item => {
          if (item.kyhieu === 'btxh') {
            if (item.items && item.items.length > 0) {
              laoCaiItems = laoCaiItems.concat(item.items);
            } else if (item.link) {
              laoCaiItems.push(item);
            }
          } else {
            laoCaiItems.push(item);
          }
        });
        this.appitems = laoCaiItems;
      } else {
        this.appitems = tmp.length > 0 ? tmp[0].items : [];
      }
      this.originMenu = this.appitems;
    }
  }
    searchText = '';
    matchedPaths: any[][] = [];
    currentMatchIndex = -1;
    searchMenu(items: any[], keyword: string): any[] {
        if (!keyword) return items;
        const lowerKeyword = keyword.toLowerCase();
        return items
            .map(item => {
            const children = item.items
                ? this.searchMenu(item.items, keyword)
                : [];

            const isMatch = item.label?.toLowerCase().includes(lowerKeyword) || item.link?.toLowerCase().includes(lowerKeyword);

            if (isMatch || children.length > 0) {
                return {
                ...item,
                expanded: false,
                items: children
                };
            }

            return null;
            })
        .filter(item => item !== null);
    }
    
    onSearchChange() {
        if(this.originMenu.length === 0){
            this.originMenu = this.appitems;
        }
        this.appitems = this.searchMenu(this.originMenu, this.searchText);
    }

    collapseAll(nodes: any[]) {
        nodes.forEach(n => {
            n.expanded = false;
            if (n.items?.length) {
                this.collapseAll(n.items);
            }
        });
    }

    collectMatchedPaths(nodes: any[], keyword: string, path: any[] = []) {
        for (const node of nodes) {
            const currentPath = [...path, node];

            if (node.label?.toLowerCase().includes(keyword.toLowerCase())) {
            this.matchedPaths.push(currentPath);
            }

            if (node.items?.length) {
            this.collectMatchedPaths(node.items, keyword, currentPath);
            }
        }
    }
    
    findNodeInAppItems(nodes: any[], target: any): any {
        for (const node of nodes) {
            if (
            node.label === target.label &&
            node.link === target.link
            ) {
            return node;
            }

            if (node.items?.length) {
            const found = this.findNodeInAppItems(node.items, target);
            if (found) return found;
            }
        }
        return null;
    }

    mapPathToAppItems(path: any[]): any[] {
        const mapped: any[] = [];

        path.forEach(p => {
            const found = this.findNodeInAppItems(this.appitems, p);
            if (found) {
            mapped.push(found);
            }
        });

        return mapped;
    }

    onSearchEnter() {
        if (!this.searchText) return;

        this.collapseAll(this.appitems);

        this.matchedPaths = [];
        this.collectMatchedPaths(this.originMenu, this.searchText);

        if (this.matchedPaths.length === 0) return;

        this.currentMatchIndex++;
        if (this.currentMatchIndex >= this.matchedPaths.length) {
            this.currentMatchIndex = 0;
        }

        const path = this.matchedPaths[this.currentMatchIndex];
        const mappedPath = this.mapPathToAppItems(path);
        this.expandPathByService(mappedPath);
    }
    
    expandPathByService(path: any[]) {
        path.forEach(p => {
            p.expanded = true;
            this.menuService.selectMenuByID(p.id);
        });
    }

  private getLabel(item: any): string {
    if (item.Path === 'lao-dong-viec-lam/nguoi-nn-lv-tai-vn/dang-ky-thong-tin-mau-03' && this.user.maTinhBhxh === '04') {
      return 'Thông tin NLĐNN làm việc tại tỉnh Cao Bằng';
    }
    if (item.MenuName === 'Người lao động Việt Nam làm việc tại nước ngoài' && this.user.maTinhBhxh === '04') 
      return 'Người lao động tỉnh Cao Bằng đi làm việc ở nước ngoài theo hợp đồng';
    if (item.MenuName === 'Danh sách người lao động Việt Nam làm việc tại nước ngoài' && this.user.maTinhBhxh === '04')
      return 'Danh sách người lao động tỉnh Cao Bằng đi làm việc ở nước ngoài theo hợp đồng';
    return item.MenuName;
  }

  getChildrentMenuList(node: any): any[] {
    const result: any[] = [];
    const listChildrent = this.menu.filter(p => p.IdParent === node.Id);

    if (listChildrent.length > 0) {
      listChildrent.forEach(item => {
        const chil = this.getChildrentMenuList(item);
        if ((!item.Path || item.Path === '') && chil.length === 0) return;

        result.push({
          label: this.getLabel(item),
          link: item.Path ? `/${item.Path}` : item.Path,
          items: chil
        });
      });
    }

    return result;
  }

  selectedItem($event) {
    this.router.navigate([$event.link]);
  }

  public avatar: string = "assets/img/user.png";

  public localeId: string = "";
  changeLanguage(lang) {
    this.translateService.use(lang);
    localStorage.setItem(KEY_LOCALSTORAGE.LANGUAGE, lang);
    this.localeId = lang;
    window.location.reload();
  }

  logout(): void {
    this.router.navigate(['dang-nhap']);
    localStorage.removeItem('access_token');
    localStorage.removeItem('status');
    localStorage.removeItem('maHuyenBtxh');
    localStorage.removeItem('maXaBtxh');
    localStorage.removeItem('kyChot');
    localStorage.removeItem('idLoaiChinhSach');
    localStorage.removeItem('isMTP');
    localStorage.removeItem('isNgay');
    localStorage.removeItem('pdfjs.history');
    localStorage.removeItem('SYSTEM_CONFIG');
    localStorage.removeItem('region');
    localStorage.removeItem('menu');
    localStorage.removeItem('user'); 
  }

  DATA_NOTIFICATION_CENTER: any[] = [];

  openBell() {
    $("#div-bell").removeClass("bell");
  }

  listenNotification() {
    this.afMessaging.messages.subscribe((message: any) => {
      $("#div-bell").addClass("bell");
      this.DATA_NOTIFICATION_CENTER.unshift({
        message: message.notification.body,
        title: message.notification.title,
        CreateDate: new Date()
      });
      let audio = new Audio();
      audio.src = "../../../assets/audio/message-notification.wav";
      audio.load();
      audio.play();
    });
  }

  roleUser = [];
  getNotification() {
    var topic = (this.roleUser.map(p => p.KY_HIEU)).join("','");
    this.danhMucServicer.getDanhMucNotification("'" + topic + "'").subscribe(res => {
      if (res) this.DATA_NOTIFICATION_CENTER = res;
    })
  }

  goToDetailMember(uuidHo, uuidNhanKhau) {
    if (uuidHo != null && uuidNhanKhau != null) this.router.navigate(["btxh-ho-ngheo", "cap-nhat-thanh-vien", uuidHo, uuidNhanKhau]);
  }

  public title;
  async checkTinhTitle() {
    if (this.user.maTinhBhxh == '49') {
      return this.title = 'Phần mềm quản lý an sinh xã hội – lao động xã hội';
    }
    if (this.maTinh == '58') {
      return this.title = 'Phần mềm Quản lý\n Giáo dục và đào tạo nghề';
    }
    if (this.user.maTinhBhxh == '89') {
      return this.title = 'HỆ THỐNG CSDL VÀ NỀN TẢNG TỔNG HỢP, PHÂN TÍCH DỮ LIỆU NGÀNH LĐTBXH';
    }
    if(this.user.maTinhBhxh == '52'){
        return this.title = 'PHẦN MỀM VÀ CƠ SỞ DỮ LIỆU HỘ NGHÈO, HỘ CẬN NGHÈO';
    }
    if (this.user.maTinhBhxh == '15') {
      return this.title = 'Phần mềm Quản lý\n ' + this.domainContext.getAppLabel();
    }
    if (this.user.maTinhBhxh == '93') {
      let title = this.getMenuFromStorage().filter(p => p.kyhieu == this.getkyHieuPhanHe(this.phanHe) && p.IdParent == null);
      return this.title = title.length > 0 ?  'Lĩnh vực ' + title[0].MenuName : 'Phần mềm Quản lý\n ' + this.domainContext.getAppLabel();
    }
    return this.title = 'Phần mềm Quản lý\n ' + this.domainContext.getAppLabel();
  }

  checkMenu(link): Boolean {
    if (link === '/tre-em/cau-hinh-danh-muc') {
      if (this.user.maTinhBhxh === '94') {
        return true;
      }
      else return false;
    }
    if (link === '/tre-em/thong-ke-tre-em/tre-em-tren-16-theo-dt') {
      if (this.user.maTinhBhxh === '87') {
        return false;
      }
      else return true;
    }
    return true;
  }
  public userInfoForm = new FormGroup({
    hoTen: new FormControl(null, [Validators.required, Validators.maxLength(255), Validators.pattern(PATTERT_SYMBOL), Validators.pattern(PATTERT_SYMBOL_NO)]),
    sdt: new FormControl(null, [Validators.required, Validators.pattern(PARTERT_PHONENUMBER)]),
    tenChucDanh: new FormControl(null)
  });

  public passwordUserForm = new FormGroup({
    matKhauCu: new FormControl(null, [Validators.required, Validators.pattern(PATTERT_PASSWORD), Validators.pattern(PATTERT_PASSWORD_NO)]),
    matKhauMoi: new FormControl(null, [Validators.required, Validators.pattern(PATTERT_PASSWORD), Validators.pattern(PATTERT_PASSWORD_NO)]),
    nhapLaiMatKhauMoi: new FormControl(null, [Validators.required, Validators.pattern(PATTERT_PASSWORD), Validators.pattern(PATTERT_PASSWORD_NO)])
  });

  userInfo() {
    this.userInfoForm.controls.hoTen.patchValue(this.user.hoTen);
    this.userInfoForm.controls.sdt.patchValue(this.user.sdt);
    this.userInfoForm.controls.tenChucDanh.patchValue(this.user.tenChucDanh);
    this.userInfoForm.controls.tenChucDanh.disable();
  }

  closeModal(id) {
    this.userInfoForm.reset();
    this.passwordUserForm.reset();
    this.functionService.closeModal(id);
  }

  openModal(id) {
    this.functionService.openModal(id);
  }

  updateUserInfo() {
    if (this.userInfoForm.valid) {
    var formObj = this.userInfoForm.getRawValue();
    this.userInfoForm.controls.hoTen.patchValue(formObj.hoTen.trim());
    this.userInfoForm.controls.sdt.patchValue(formObj.sdt.trim());
    var obj = {
      hoTen: formObj.hoTen.trim(),
      sdt: formObj.sdt.trim(),
    }
    
      this.userService.updateUserInfo(obj).subscribe(res => {
        this.user.hoTen = formObj.hoTen.trim();
        this.user.sdt = formObj.sdt.trim();
        localStorage.setItem('user', JSON.stringify(this.user));
        this.userInfo()
        this.closeModal('userInfo');
        this.message.showMessage(this.translate.instant("MESSAGE.SUCCESS.N003"), MESSAGE_TYPE.SUCCESS);
      }, error => {
        this.message.showMessage(this.translate.instant("MESSAGE.ERROR.E003"), MESSAGE_TYPE.ERROR);
      });
    }
  }

  updatePasswordUser() {
    var formObj = this.passwordUserForm.getRawValue();
    var obj = {
      matKhauCu: this.encryptUsingAES256(formObj.matKhauCu),
      matKhauMoi: this.encryptUsingAES256(formObj.matKhauMoi),
    }
    if (this.passwordUserForm.valid) {
      if (this.validateInput(formObj.matKhauCu, formObj.matKhauMoi, formObj.nhapLaiMatKhauMoi)) {
        this.spinner.show();
        this.userService.updatePasswordUser(obj).subscribe(res => {
            this.spinner.hide();
          this.closeModal('password');
          this.passwordUserForm.reset();
          this.message.showMessage(this.translate.instant("MESSAGE.SUCCESS.N003"), MESSAGE_TYPE.SUCCESS);
        }, error => {
            this.spinner.hide();
          this.message.showError("Mật khẩu cũ không đúng", 'warning_notification');
        });
      }
    }
  }

  hidePassword = true;
  encryptUsingAES256(password) {
    let _key = CryptoJS.enc.Utf8.parse(environment.cipherKeyRegistry);
    let _iv = CryptoJS.enc.Utf8.parse(environment.cipherKeyRegistry);
    let encrypted = CryptoJS.AES.encrypt(password, _key, {
      keySize: 16,
      iv: _iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  }

  validate = true;
  validateInput(password, newPassword, rePassword) {
    if (BLACKLISTPASS.includes(newPassword.toLowerCase())) {
      this.message.showError('Mật khẩu mới yếu, vi phạm ATTT. Vui lòng dùng mật khẩu khác!', 'warning_notification');
      this.validate = false;
    }
    if (newPassword == password) {
      this.message.showError('Mật khẩu mới không đặt trùng mật khẩu cũ', 'warning_notification');
      this.validate = false;
    } else if (rePassword != newPassword) {
      this.message.showError('Mật khẩu nhập lại không đúng', 'warning_notification');
      this.validate = false;
    } else {
      this.validate = true;
    }
    return this.validate;
  }
  async checkingPasswordExpire() {
    try {
      if(this.user.maTinhBhxh != 96){
        let checkingPasswordExpire = await this.auth.checkingPasswordExpire();
        if (checkingPasswordExpire) {
            if (checkingPasswordExpire.status == 0) {
              this.openModal('password');
              $('button[id="refersh-Family-btn"]').eq(2).attr('disabled', 'disabled');
              this.message.showMessage("Mật khẩu đã quá hạn! Vui lòng đổi mật khẩu mới", MESSAGE_TYPE.WARNING);
            }
            else{
              $('button[id="refersh-Family-btn"]').eq(1).removeAttr('disabled');
            }
        }
      }
    } catch (e) {
        console.log(e)
    }
  }

    userIdForm = new FormGroup({
        tenDangNhapQLVB: new FormControl(null, [Validators.required]),
        matKhauQLVB: new FormControl(null, [Validators.required])
    });

    ngOnInitUserId() {
        this.userIdForm.get('tenDangNhapQLVB')?.patchValue(this.user.usernameQLVB);
    }
    submitUserId() {
        if (this.userIdForm.valid) {
            this.closeModal('modalUserId_admin');
            var obj = {
                tenDangNhapQLVB: this.userIdForm.value.tenDangNhapQLVB,
                matKhauQLVB: this.encryptUsingAES256(this.userIdForm.value.matKhauQLVB),
            }
            this.apiCapNhatTaiKhoanQLVB(obj);
            // Cập nhật giá trị từ form
            this.user.usernameQLVB = this.userIdForm.get('tenDangNhapQLVB')?.value;
            // Ghi lại vào localStorage
            localStorage.setItem('user', JSON.stringify(this.user));
        }
    }

    apiCapNhatTaiKhoanQLVB(requestBody) {
    this.spinner.show();
    this.userService.capNhatTaiKhoanQLVB(requestBody).subscribe(data => {
      this.spinner.hide();
      this.message.showMessage(this.translate.instant("MESSAGE.SUCCESS.N003"), MESSAGE_TYPE.SUCCESS);
      this.closeModal('modalUserId_admin');
      this.userIdForm.get('matKhauQLVB')?.patchValue('')

    }, err => {
      this.message.showMessage(this.translate.instant("MESSAGE.ERROR.E003"), MESSAGE_TYPE.ERROR);
      this.spinner.hide();
    });
  }

    togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
    }

     // Thông tin doanh nghiệp
    private subscription: Subscription[] = [];
    ngOnDestroy() {
        this.subscription.forEach(subscription => {
        if (subscription != undefined) subscription.unsubscribe();
        });
    }

    addGPKDForm = new FormGroup({});
    rows = new FormArray([]);
    date = new Date();
    addForm = new FormGroup({
        id: new FormControl(null),
        maTinh: new FormControl(null,[Validators.required]),
        maXa: new FormControl(null,[Validators.required]),
        tenCoSo: new FormControl(null, [Validators.required, Validators.pattern(PATTERT_SYMBOL)]),
        maSoThue: new FormControl(null, [Validators.required, Validators.pattern(PATTERT_SYMBOL)]),
        loaiHinhCoSo: new FormControl(null, [Validators.required]),
        ngayThanhLap: new FormControl(null, [Validators.pattern(PATTERN_DATE2)]),
        linhVucSanXuatChinh: new FormControl(null, [Validators.required]),
        tinhTrangHoatDong: new FormControl(null, [Validators.required]),
        soDienThoai: new FormControl(null, [Validators.pattern(PARTERT_PHONENUMBER)]),
        fax: new FormControl(null, [Validators.pattern(PATTERT_SYMBOL)]),
        email: new FormControl(null,[Validators.pattern(PATTERT_EMAIL)]),
        diaChi: new FormControl(null, [Validators.pattern(PATTERT_SYMBOL)]),
        hoTen: new FormControl(null, [Validators.pattern(PATTERT_HOTEN)]),
        gioiTinh: new FormControl(null),
        ngaySinh: new FormControl(null, [Validators.pattern(PATTERN_DATE2)]),
        chucDanh: new FormControl(null, [Validators.pattern(PATTERT_SYMBOL)]),
        cccd: new FormControl(null, [Validators.pattern(PATTERN_CMND)]),
        ngayCap: new FormControl(null,[Validators.pattern(PATTERN_DATE2)]),
        noiCap: new FormControl(null),
        webSite: new FormControl(null),
        toChucCongDoan: new FormControl(null),
        namThanhLapCongDoan: new FormControl({value:null, disabled:true},[Validators.pattern(PATTERN_DATE2)]),
        cqQuabLyTrucTiep: new FormControl(null),
        sdtDD: new FormControl(null, [Validators.pattern(PARTERT_PHONENUMBER)]),
        emailDD: new FormControl(null, [Validators.pattern(PATTERT_EMAIL)]),
        uuidNguoiDung: new FormControl(null),
        trangThaiBanHanhNoiQuy: new FormControl(0),
        ngayBanHanhNoiQuy: new FormControl(null, [Validators.pattern(PATTERN_DATE2)]),
        coQuanXetNoiQuy: new FormControl(null, [Validators.pattern(PATTERT_SYMBOL)]),
        trangThaiBanHanhThoaUocLdtt: new FormControl(0),
        ngayBanHanhThoaUocLdtt: new FormControl(null, [Validators.pattern(PATTERN_DATE2)]),
        coQuanXetThoaUocLdtt: new FormControl(null, [Validators.pattern(PATTERT_SYMBOL)]),
        loaiDoanhNghiep: new FormControl(1)
    });
    keyPressNumber(event) {
        return this.functionService.allowPressNumber(event);
    }

    keyPressDot(event) {
        return this.functionService.allowPressDot(event) || this.functionService.allowPressNumber(event);
    }

    keyPressDate(event) {
        return this.functionService.allowPressDate(event) || this.functionService.allowPressNumber(event);
    }
    allowPressNumber(event) {
        return this.functionService.allowPressNumber(event);
    }

    allowPressDate(event) {
        return this.functionService.allowPressDate(event) || this.functionService.allowPressNumber(event);
    }

    danhMucTinhThanhAdd;
    danhMucPhuongXaAdd;

    onAddRow() {
        this.rows.push(this.createItemFormGroup());
    }

    createItemFormGroup(): FormGroup {
        return this.formBuilder.group({
            id: new FormControl(''),
            ngayCapGiayPhep: new FormControl(null, [Validators.required,Validators.pattern(PATTERN_DATE2)]),
            loaiGiayPhep: new FormControl(null, [Validators.required, Validators.pattern(PATTERT_SYMBOL)]),
            fileName: new FormControl(null, [Validators.required]),
            idfile: new FormControl(''),
        });
    }
    async setMaTinh() {
        this.danhMucPhuongXaAdd =[];
        if(this.addForm.controls.maTinh.value!=null){
            this.danhMucPhuongXaAdd = await this.apiGetPhuongXa(this.addForm.controls.maTinh.value);
        }
    }
    formInitAddChiTiet() {
        this.addGPKDForm.addControl('rows', this.rows);
    }

    resetFormArray() {
        while (this.rows.length != 0) {
            this.rows.removeAt(0);
        }
    }
    async resetForm(form: FormGroup, formDirective?: FormGroupDirective) {
        ValidationService.resetForm(form, formDirective);
        this.formInitAddChiTiet();
        this.resetFormArray();
        this.addForm.controls.namThanhLapCongDoan.disable();
        this.addForm.controls.maTinh.patchValue(this.user?.maTinhBhxh);
        this.addForm.controls.maXa.patchValue(this.user?.maXaPhuongBhxh);
        this.addForm.controls.maTinh.disable();
    }

    listDelete = [];
    xoaDong(rowIndex: number, idGPKD) {
        if (idGPKD != null && idGPKD!="" && !ValidationService.isBlank(idGPKD)) {
            let id = this.listDelete.find((id) => id == idGPKD);
            if (id == null || this.listDelete.length == 0) {
            this.listDelete.push(idGPKD);
            }
        }
        this.rows.removeAt(rowIndex);
    }
    async apiGetThongTinChiTiet(id) {
        this.spinner.show();
        await this.setUpDanhMucThongTinDoanhNghiep();
        this.subscription.push(this.viecLamService.getTTDoanhNghiepbyID(id).subscribe(async data => {
            await this.setViewCapNhat(data);
            this.openModal('addThongTinDoanhNhiep');
            this.spinner.hide();
        }))
    }
    danhMucLoaiDoanhNghiep = [];
    apiGetLoaiDoanhNghiep() {
        return this.viecLamService.dmDungChung_QLDN("LOAI_DOANH_NGHIEP").toPromise();
    }
    danhMucLinhVucSXChinh = [];
    apiGetLinhVucSXChinh() {
        return this.viecLamService.danhMucNganhNgheKinhTe().toPromise();
    }
    danhMucLoaiHinhCoSo = [];
    apiGetLoaiHinhCoSo() {
        return this.viecLamService.dmDungChung_QLDN("LOAI_HINH_CO_SO").toPromise();
    }

    danhMucTinhTrangHoatDong = [];
    apiGetTinhTrangHoatDong() {
        return this.viecLamService.dmDungChung_QLDN("TINH_TRANG_HOAT_DONG").toPromise();
    }

    danhMucGioiTinh = [];
    apiGetGioiTinh() {
        return this.viecLamService.dmDungChung_QLDN("GIOI_TINH").toPromise();
    }
    async apiGetTinhThanh() {
        return this.regionService.getTinh().toPromise();
    }

    async apiGetPhuongXa(maTinh) {
        return this.regionService.getXa(maTinh).toPromise();
    }
    async setUpDanhMucThongTinDoanhNghiep(){
        this.danhMucTinhThanhAdd  = await this.apiGetTinhThanh();
        this.danhMucPhuongXaAdd = await this.apiGetPhuongXa(this.user.maTinhBhxh);
        this.danhMucLoaiDoanhNghiep = await this.apiGetLoaiDoanhNghiep();
        this.danhMucLinhVucSXChinh = await this.apiGetLinhVucSXChinh();
        this.danhMucLoaiHinhCoSo = await this.apiGetLoaiHinhCoSo();
        this.danhMucTinhTrangHoatDong = await this.apiGetTinhTrangHoatDong();
        this.danhMucGioiTinh = await this.apiGetGioiTinh();
    }

    async setViewCapNhat(data) {
        const thongTinCoSo = data.thongTinCoSo;
        const giayPhepKinhDoanh = data.giayPhepKinhDoanh;
        if(thongTinCoSo?.maTinh){
            this.danhMucPhuongXaAdd = await this.apiGetPhuongXa(thongTinCoSo?.maTinh);
        }
        this.addForm.controls.id.patchValue(thongTinCoSo.id);
        this.addForm.controls.loaiDoanhNghiep.patchValue(thongTinCoSo.loaiDoanhNghiep);
        this.addForm.controls.tenCoSo.patchValue(thongTinCoSo.tenCoSo);
        this.addForm.controls.maSoThue.patchValue(thongTinCoSo.maSoThue);
        this.addForm.controls.loaiHinhCoSo.patchValue(thongTinCoSo.loaiHinhCoSo);
        this.addForm.controls.ngayThanhLap.patchValue(thongTinCoSo.ngayThanhLap);
        this.addForm.controls.linhVucSanXuatChinh.patchValue(Number(thongTinCoSo.linhVucSanXuatChinh));
        this.addForm.controls.tinhTrangHoatDong.patchValue(Number(thongTinCoSo.tinhTrangHoatDong));
        this.addForm.controls.soDienThoai.patchValue(thongTinCoSo.soDienThoai);
        this.addForm.controls.fax.patchValue(thongTinCoSo.fax);
        this.addForm.controls.email.patchValue(thongTinCoSo.email);
        this.addForm.controls.maTinh.patchValue(thongTinCoSo.maTinh);
        this.addForm.controls.maXa.patchValue(thongTinCoSo.maXa);
        this.addForm.controls.diaChi.patchValue(thongTinCoSo.diaChi);
        this.addForm.controls.hoTen.patchValue(thongTinCoSo.hoTen);
        this.addForm.controls.gioiTinh.patchValue(Number(thongTinCoSo.gioiTinh));
        this.addForm.controls.ngaySinh.patchValue(thongTinCoSo.ngaySinh);
        this.addForm.controls.chucDanh.patchValue(thongTinCoSo.chucDanh);
        this.addForm.controls.cccd.patchValue(thongTinCoSo.cccd);
        this.addForm.controls.ngayCap.patchValue(thongTinCoSo.ngayCap);
        this.addForm.controls.noiCap.patchValue(thongTinCoSo.noiCap);
        this.addForm.controls.webSite.patchValue(thongTinCoSo.webSite);
        this.addForm.controls.cqQuabLyTrucTiep.patchValue(thongTinCoSo.coQuanQuanLyCapTren);
        this.addForm.controls.toChucCongDoan.patchValue(thongTinCoSo.toChucCongDoan);
        this.addForm.controls.namThanhLapCongDoan.patchValue(thongTinCoSo.namThanhLapCongDoan);
        this.addForm.controls.sdtDD.patchValue(thongTinCoSo.sdtDD);
        this.addForm.controls.emailDD.patchValue(thongTinCoSo.emailDD);
        this.addForm.controls.uuidNguoiDung.patchValue(thongTinCoSo.uuIdNguoiDung);
        this.addForm.controls.trangThaiBanHanhNoiQuy.patchValue(Number(thongTinCoSo.trangThaiBanHanhNoiQuy));
        this.addForm.controls.ngayBanHanhNoiQuy.patchValue(thongTinCoSo.ngayBanHanhNoiQuy);
        this.addForm.controls.coQuanXetNoiQuy.patchValue(thongTinCoSo.coQuanXetNoiQuy);
        this.addForm.controls.trangThaiBanHanhThoaUocLdtt.patchValue(Number(thongTinCoSo.trangThaiBanHanhThoaUocLdtt));
        this.addForm.controls.ngayBanHanhThoaUocLdtt.patchValue(thongTinCoSo.ngayBanHanhThoaUocLdtt);
        this.addForm.controls.coQuanXetThoaUocLdtt.patchValue(thongTinCoSo.coQuanXetThoaUocLdtt);

        if(thongTinCoSo.toChucCongDoan==1){
        this.addForm.controls.namThanhLapCongDoan.enable();
        }
        this.addGPKDForm = new FormGroup({});
        this.listDelete = [];
        this.rows.removeAt(0);
        giayPhepKinhDoanh.forEach(element=>{
        var item = this.formBuilder.group({
            id: element.id,
            idDoanhNghiep: element.idDoanhNghiep,
            ngayCapGiayPhep: element.ngayCapGiayPhep,
            loaiGiayPhep: element.loaiGiayPhep,
            fileName: element.fileName,
            idfile: element.file,
            flag: new FormControl(false),
        });
        this.rows.push(item);
        })
        this.addGPKDForm.addControl('rows', this.rows);
    }

    capNhat() {
        if (this.addForm.valid && this.rows.valid) {
            let formGroup = new FormGroup({});
            let formTmp = formGroup.getRawValue();
            let form = this.addForm.getRawValue();
            formTmp.id = form.id;
            formTmp.maTinh = (form.maTinh == null || form.maTinh == 'null') ? null : form.maTinh;
            formTmp.maXa = (form.maXa == null || form.maXa == 'null') ? null : form.maXa;
            formTmp.diaChi = (form.diaChi == null || form.diaChi == '') ? "" : form.diaChi.toString().trim();
            formTmp.tenCoSo = (form.tenCoSo == null || form.tenCoSo == '') ? null : form.tenCoSo.toString().trim();
            formTmp.maSoThue = (form.maSoThue == null || form.maSoThue == '') ? null : form.maSoThue.toString().trim();
            formTmp.loaiHinhCoSo = (form.loaiHinhCoSo == null || form.loaiHinhCoSo == 'null')?null:form.loaiHinhCoSo;
            formTmp.ngayThanhLap = (form.ngayThanhLap == null || form.ngayThanhLap == '') ? null : this.datePipe.transform(form.ngayThanhLap, DATE_PATTERN.NORMAL_FORMAT);
            formTmp.linhVucSanXuatChinh = (form.linhVucSanXuatChinh == null || form.linhVucSanXuatChinh == 'null')?null:Number(form.linhVucSanXuatChinh);
            formTmp.tinhTrangHoatDong = (form.tinhTrangHoatDong == null || form.tinhTrangHoatDong == 'null')?null: Number(form.tinhTrangHoatDong);
            formTmp.soDienThoai = (form.soDienThoai == null || form.soDienThoai == '') ? "" : form.soDienThoai.toString().trim();
            formTmp.fax = (form.fax == null || form.fax == '') ? "" : form.fax.toString().trim();
            formTmp.email = (form.email == null || form.email == '') ? "" : form.email.toString().trim();
            formTmp.loaiDoanhNghiep = form.loaiDoanhNghiep;
            formTmp.hoTen = (form.hoTen == null || form.hoTen == '') ? null : form.hoTen.toString().trim();
            formTmp.gioiTinh = (form.gioiTinh == null || form.gioiTinh == 'null') ? null : Number(form.gioiTinh);
            formTmp.ngaySinh = (form.ngaySinh == null || form.ngaySinh == '') ? null : this.datePipe.transform(form.ngaySinh, DATE_PATTERN.NORMAL_FORMAT);
            formTmp.chucDanh = (form.chucDanh == null || form.chucDanh == 'null') ? null : form.chucDanh;
            formTmp.cccd = (form.cccd == null || form.cccd == '') ? "" : form.cccd.toString().trim();
            formTmp.ngayCap = (form.ngayCap == null || form.ngayCap == '') ? "" : this.datePipe.transform(form.ngayCap, DATE_PATTERN.NORMAL_FORMAT);
            formTmp.noiCap = (form.noiCap == null || form.noiCap == '') ? "" : form.noiCap.toString().trim();
            formTmp.webSite = (form.webSite == null || form.webSite == '') ? null : form.webSite.toString().trim();
            formTmp.coQuanQuanLyCapTren = (form.cqQuabLyTrucTiep == null || form.cqQuabLyTrucTiep == '') ? null : form.cqQuabLyTrucTiep.toString().trim();
            formTmp.toChucCongDoan = Number(form.toChucCongDoan);
            formTmp.namThanhLapCongDoan = (form.namThanhLapCongDoan == null || form.namThanhLapCongDoan == '') ? null : this.datePipe.transform(form.namThanhLapCongDoan, DATE_PATTERN.NORMAL_FORMAT);
            formTmp.sdtDD = (form.sdtDD == null || form.sdtDD == '') ? null : form.sdtDD.toString().trim();
            formTmp.emailDD = (form.emailDD == null || form.emailDD == '') ? null : form.emailDD.toString().trim();
            formTmp.trangThai = 1;
            formTmp.trangThaiBanHanhNoiQuy = form.trangThaiBanHanhNoiQuy
            formTmp.ngayBanHanhNoiQuy = (form.ngayBanHanhNoiQuy == null || form.ngayBanHanhNoiQuy == '') ? null : this.datePipe.transform(form.ngayBanHanhNoiQuy, DATE_PATTERN.NORMAL_FORMAT);
            formTmp.coQuanXetNoiQuy = (form.coQuanXetNoiQuy == null || form.coQuanXetNoiQuy == '') ? "" : form.coQuanXetNoiQuy.toString().trim();
            formTmp.trangThaiBanHanhThoaUocLdtt = form.trangThaiBanHanhNoiQuy
            formTmp.ngayBanHanhThoaUocLdtt = (form.ngayBanHanhThoaUocLdtt == null || form.ngayBanHanhThoaUocLdtt == '') ? null : this.datePipe.transform(form.ngayBanHanhThoaUocLdtt, DATE_PATTERN.NORMAL_FORMAT);
            formTmp.coQuanXetThoaUocLdtt = (form.coQuanXetThoaUocLdtt == null || form.coQuanXetThoaUocLdtt == '') ? "" : form.coQuanXetThoaUocLdtt.toString().trim();
            let listGPKDAdd = [];
            let listGPKDUpdate = [];
            let giayPhepKinhDoanhDto_add = this.rows.value;
            if(giayPhepKinhDoanhDto_add.length > 0){
            giayPhepKinhDoanhDto_add.forEach(element => {
                element.idDoanhNghiep=formTmp.id;
                element.ngayCapGiayPhep=this.datePipe.transform(element.ngayCapGiayPhep,DATE_PATTERN.NORMAL_FORMAT);
                element.loaiGiayPhep=element.loaiGiayPhep;
                element.file=element.idfile;
                element.id=element.id;
                if(!ValidationService.isBlank(element.id)){
                listGPKDUpdate.push(element);
                }else{
                listGPKDAdd.push(element);
                }
            });
            }
            formTmp.giayPhepKinhDoanhDto_add = listGPKDAdd;
            formTmp.giayPhepKinhDoanhDto_update = listGPKDUpdate;
            formTmp.giayPhepKinhDoanhDto_delete = this.listDelete;
            this.addForm.controls.namThanhLapCongDoan.disable()
            this.apiCapNhat(JSON.stringify(formTmp, null, 2));
        }else{
            this.message.showMessage(this.translate.instant('MESSAGE.WARNING.W007'), MESSAGE_TYPE.WARNING);
        }
        }
    apiCapNhat(requestBody) {
        this.subscription.push(this.viecLamService.capNhatDoanhNghiep(requestBody).subscribe(async data => {
        if(data.status==0){
            this.message.showMessage(data.message, MESSAGE_TYPE.SUCCESS);
            this.listDelete=[];
        }
        if(data.status>0 && data.status <100){
            this.message.showMessage(data.message, MESSAGE_TYPE.WARNING);
        }
        if(data.status >=100){
            this.message.showMessage(data.message, MESSAGE_TYPE.ERROR);
        }
        }, err=>{
            this.message.showMessage(this.translate.instant('MESSAGE.ERROR.E003'), MESSAGE_TYPE.ERROR);
        }));
    }
    onFileChange(event: any, index: number) {
        const file = event.target.files[0];
        if (file) {
            this.spinner.show();
            const fileName = file.name;
            const rows = this.addGPKDForm.get('rows') as FormArray;
            const row = rows.at(index);
            this.subscription.push(this.viecLamService.layIDFileGPKD(file).subscribe(data => {
            this.spinner.hide();
            row.get('idfile')?.setValue(data.dsIdFile);
            row.get('fileName')?.setValue(fileName);
            }, err => {
            this.spinner.hide();
            }));
        }
    }
    downFileGPKD(event: any, idfile, fileName){
        event.preventDefault();
        event.stopImmediatePropagation();
        this.spinner.show();
        this.subscription.push(this.viecLamService.downFileGPKD(idfile,fileName).subscribe(data => {
            this.spinner.hide();
        }, err => {
        this.spinner.hide();
        this.message.showMessage(this.translate.instant('MESSAGE.ERROR.E010'), MESSAGE_TYPE.ERROR);
        }));
    }
    trimSpace(event, formControl) {
        this.validationService.trimSpace(event, formControl);
    }
    checkThanhLapCongDoan(check,rownamThanhLapCongDoan){
        check?rownamThanhLapCongDoan.enable():rownamThanhLapCongDoan.disable();
        if(check == null || check == "0"){
            rownamThanhLapCongDoan.setValue(null);
        }else{
            rownamThanhLapCongDoan.enable();
        }
    }
    validateInputDN(event: Event) {
        const input = event.target as HTMLInputElement;
        let value = input.value;
        if (value.includes('%')) {
            value = value.replace(/%/g, '');
        }
        input.value = value;
        if (value !== input.value) {
            this.message.openSnackBar('Không cho phép nhập dấu %!', '', '', 'error_notification');
        }
   }
}
